import { useContext } from "react";

import Button from "components/Form/Button";
import { CoreContext } from "context/CoreContext";
import {
  CardEmptyContainer,
  CardEmptyText,
  CardEmptyTitle,
  CreatorsCardEmptyImage,
  ScheduleInvalidLinkImage,
} from "./styled";

export default function ScheduleCardEmpty({
  campaign,
  reload,
  title = "Adicionar cronograma desta campanha",
  description = "Adicione cronograma por meio de links de docs.",
  buttonText = "ADICIONAR CRONOGRAMA",
  error = false,
}) {
  const { setModal } = useContext(CoreContext);
  const item = error ? { ...campaign, type: "edit" } : campaign;
  return (
    <>
      <CardEmptyContainer>
        {error ? <ScheduleInvalidLinkImage /> : <CreatorsCardEmptyImage />}
        <CardEmptyTitle>{title}</CardEmptyTitle>
        <CardEmptyText>{description} </CardEmptyText>
        <div style={{ height: "48px", marginBottom: "32px" }}>
          <Button
            primary
            nospace
            onClick={() =>
              setModal({ type: "add-schedule", item: item, reload })
            }
            disabled={campaign?.status === "finished"}
          >
            {buttonText}
          </Button>
        </div>
      </CardEmptyContainer>
    </>
  );
}
